import { useEnv } from '@btcdirect/shared/src/composables/util/env';

const assets = useEnv().getString('VITE_ASSET_URL', '/');

export const useImageLoad = () => {
    const get = (name: string, directory: string, extension: string = 'svg') => {
        return `${getImageDirectory(directory)}/${name}.${extension}`;
    };

    return {
        get
    };
};

function getImageDirectory(directory?: string) {
    if (!directory) {
        return `${assets}img`;
    }

    return `${assets}img/${directory}`;
}
